import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import manifestJson from '../../../../../../../manifest.json';
const AboutPage = ({ setTitleContainerProperties }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_about',
            isBackButtonEnabled: true,
        });
    }, []);
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_ABOUT}-page`, className: "about-page" },
        React.createElement("div", { "data-testid": `${SVGIcons.MENU_ABOUT}-page-content`, className: "content", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_about_text'),
            } }),
        React.createElement("div", { className: "version" },
            React.createElement("p", null,
                React.createElement("strong", null, manifestJson.name + ' ' + manifestJson.version)))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, { setTitleContainerProperties });
export const AboutPageComponent = connector(AboutPage);
